import React, { useEffect } from "react";
import Navibar from "../components/Navibar";
import Footer from "../components/Footer";
import baguetteBox from "baguettebox.js"; // Import baguetteBox
import "baguettebox.js/dist/baguetteBox.min.css"; // Import CSS

import Certifications from "../components/Certifications";

export default function Fabrics() {
  // Reusable FabricCard Component
  const FabricCard = ({ imgSrc, altText, description }) => {
    return (
      <div className="col-sm-6 col-md-4 pb-3">
        <a
          className="lightbox wow zoomIn lister bg-dark"
          href={imgSrc}
          style={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
            overflow: "hidden",
          }}
        >
          <div style={{ width: "100%", height: "100%", overflow: "hidden" }}>
            <img
              src={imgSrc}
              alt={altText}
              style={{
                width: "100%",
                height: "inherit",
                maxHeight: "100%",
                objectFit: "fill",
              }}
            />
          </div>
          <p>{description}</p>
        </a>
      </div>
    );
  };

  // Fabric data
  const fabrics = [
    {
      imgSrc: "/img/Products/banquet/banquet1.png",
      altText: "Bridge",
      description: "Napkins",
    },
    {
      imgSrc: "/img/Products/banquet/banquet2.png",
      altText: "Park",
      description: "Chair covers",
    },
    {
      imgSrc: "/img/Products/banquet/banquet3.png",
      altText: "Tunnel",
      description: "Bow Chair cover",
    },
    {
      imgSrc: "/img/Products/banquet/banquet4.png",
      altText: "Traffic",
      description: "Linen Table cloths",
    },
    {
      imgSrc: "/img/Products/banquet/banquet5.png",
      altText: "Coast",
      description: "Banquet Table Sets",
    },
    {
      imgSrc: "/img/Products/banquet/banquet6.png",
      altText: "Rails",
      description: "Napkins",
    },
    {
      imgSrc: "/img/Products/banquet/banquet7.png",
      altText: "Rails",
      description: "Satin Runner sets",
    },
    {
      imgSrc: "/img/Products/banquet/banquet8.png",
      altText: "Rails",
      description: "Pleated Table Cloths",
    },
    {
      imgSrc: "/img/Products/banquet/banquet9.png",
      altText: "Rails",
      description: "Embroidered Napkin Sets",
    },
    {
      imgSrc: "/img/Products/banquet/banquet10.png",
      altText: "Rails",
      description: "Place mats",
    },
  ];

  useEffect(() => {
    baguetteBox.run(".tz-gallery");
  }, []); // Run only once after the component mounts

  return (
    <>
      <Navibar />
      <div className="page-title-area">
        <div className="d-table">
          <div className="d-table-cell">
            <div className="container">
              <h2>Banquet Linen</h2>
              <p>
                Our banquet linen collection is thoughtfully designed to elevate
                your events with exceptional style and comfort. Crafted with
                meticulous attention to detail, our selection includes
                tablecloths, napkins, overlays, and runners, ensuring every
                occasion is beautifully set.
              </p>
              <div className="d-flex justify-content-around">
                <p className="text-bullet">
                  <li> Chair Covers</li>
                  <li>Chair Bows</li>
                </p>
                <p className="text-bullet">
                  <li> Banquet Runners</li>
                  <li>Table Cloths & Frills</li>
                </p>
                <p className="text-bullet">
                  <li>Napkin Sets</li>
                  <li>Place Mats</li>
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="tz-gallery">
        <div className="row">
          {fabrics.map((fabric, index) => (
            <FabricCard
              key={index} // Use index but ideally use a unique id
              imgSrc={fabric.imgSrc}
              altText={fabric.altText}
              description={fabric.description}
            />
          ))}
        </div>
      </div>

      <Certifications />
      <Footer />
    </>
  );
}
